module.exports = __webpack_public_path__ + "static/media/price-tag.630fe28d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price-tag.svg
// module id = 2027
// module chunks = 33